// extracted by mini-css-extract-plugin
export var chip = "_3z-0";
export var filterDropdown = "_3z-5";
export var filterItem = "_3z-6";
export var icon = "_3z-1";
export var removeButton = "_3z-3";
export var removeIcon = "_3z-4";
export var separator = "_3z-2";